import React from 'react';
import EnergyFlowSimulator from '@/components/sandbox/EnergyFlowSimulator';

const CRMSandboxEnergyFlow = () => {
  return (
    <div className="h-screen w-full overflow-hidden bg-background">
      <EnergyFlowSimulator />
    </div>
  );
};

export default CRMSandboxEnergyFlow;
